export const inviteCodeFields = [
  "no1",
  "no2",
  "no3",
  "no4",
  "no5",
  "no6",
] as const

export type InviteCodeField = (typeof inviteCodeFields)[number]

export type InviteCodeState = Record<InviteCodeField, string>
